import React from 'react';
import classes from './Order.module.css';
import Burger from '../../../stateless/burger/burger';

const Order = (props) => {
    const list = [];

    for(let prop in props.ingredients){
        list.push({name : prop,
            amount : props.ingredients[prop]})
    }

    const out = list.map(ig => {
        if(ig.amount > 0){
            return <span key={ig.name} style={{
                textTransform:'capitalize',
                padding: '5px',
                margin : '0 8px',
                display: 'inline-block',
                border: '1px solid #ccc'
            }}>{ig.name} : {ig.amount}</span>;
        }
        return null;
    })

    return (
        <div className={classes.Order}>
            <Burger overide={{margin:"0px",height:'200px'}}          
            ingredients={props.ingredients}></Burger>
            <div style={{width:'100%'}}>
                {out}
                <p>Price <strong>{props.price}</strong></p>
            </div>
        </div>
    );

}

export default Order;